"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchApiItemsUrl = exports.fetchApiItems = void 0;
const feed_factory_models_tuning_props_1 = require("@feed-factory/feed-factory.models.tuning-props");
const feed_factory_helpers_1 = require("@feed-factory/feed-factory.helpers");
const fetchApiItems = (entityType, page, size, tuningProps, cancelTokenSource, format = "json") => {
    const url = (0, exports.fetchApiItemsUrl)(entityType, page, size, tuningProps, format);
    return feed_factory_helpers_1.feedFactoryAxios.get(url, {
        cancelToken: cancelTokenSource === null || cancelTokenSource === void 0 ? void 0 : cancelTokenSource.token,
    });
};
exports.fetchApiItems = fetchApiItems;
const fetchApiItemsUrl = (entityType, page, size, tuningProps, format = "json") => {
    const apiType = entityType === "EVENEMENT" ? "events" : "locations";
    let queryString = "";
    if (!tuningProps.search && tuningProps.sortField) {
        queryString += `&sortField=${tuningProps.sortField}`;
    }
    if (!tuningProps.search && tuningProps.sortOrder) {
        queryString += `&sortOrder=${tuningProps.sortOrder}`;
    }
    if (tuningProps.search) {
        queryString += `&search=${tuningProps.search}`;
    }
    if (tuningProps.filters) {
        const filtersString = (0, feed_factory_models_tuning_props_1.filtersObjectToQueryString)(tuningProps.filters);
        queryString += filtersString ? `&${filtersString}` : "";
    }
    return `/${apiType}?page=${page}&size=${size}&format=${format}${queryString}`;
};
exports.fetchApiItemsUrl = fetchApiItemsUrl;
//# sourceMappingURL=fetchApiItems.js.map